import React from "react";

const PartnerSection = () => {
  // Partner Data with image paths
  const partners = [
    {
      id: 1,
      name: "Airtel",
      logo: "/images/airtel-logo.png",
      color: "#E60000",
      bgLight: "#FFF5F5",
    },
    {
      id: 1,
      name: "Mobikwik",
      logo: "/images/mobikwik-logo.png",
      color: "#1E3A8A",
      bgLight: "#FFF5F5",
    },
    {
      id: 1,
      name: "UTIITSL",
      logo: "/images/uti-logo.png",
      color: "#1E3A8A",
      bgLight: "#FFF5F5",
    },
    {
      id: 2,
      name: "Protean",
      logo: "/images/protean-logo.png",
      color: "#2E7D32",
      bgLight: "#F1F8E9",
    },
    {
      id: 3,
      name: "NPCI",
      logo: "/images/npci-logo.png",
      color: "#1E3A8A",
      bgLight: "#EEF2FF",
    },
  ];

  // Fallback text in case images don't load
  const getInitials = (name) => {
    return name.charAt(0);
  };

  return (
    <section id="partners" className="partner-section py-5">
      <div className="container">
        <div className="row justify-content-center text-center mb-4">
          <div className="col-lg-8">
            <span className="partner-badge">
              <i className="fas fa-handshake me-2"></i> Our Strategic Partners
            </span>
            <h2 className="display-5 fw-bold mt-3" style={{ color: "#0A2540" }}>
              Trusted By Industry Leaders
            </h2>
            <p className="lead text-muted">
              We collaborate with India's most trusted financial and technology
              partners
            </p>
          </div>
        </div>

        {/* Auto-scrolling Carousel */}
        <div className="carousel-wrapper">
          <div className="logo-carousel">
            {/* First set of logos */}
            <div className="carousel-slide">
              {partners.map((partner) => (
                <div key={partner.id} className="partner-card">
                  <div
                    className="partner-logo-circle"
                    style={{
                      backgroundColor: partner.bgLight,
                      borderColor: partner.color,
                    }}
                  >
                    <img
                      src={partner.logo}
                      alt={partner.name}
                      className="partner-image"
                      onError={(e) => {
                        e.target.style.display = "none";
                        e.target.nextSibling.style.display = "flex";
                      }}
                    />
                    <div
                      className="partner-fallback"
                      style={{ display: "none" }}
                    >
                      <span>{getInitials(partner.name)}</span>
                    </div>
                  </div>
                  <h5 className="partner-name" style={{ color: partner.color }}>
                    {partner.name}
                  </h5>
                </div>
              ))}
            </div>

            {/* Duplicate set for seamless loop */}
            <div className="carousel-slide">
              {partners.map((partner) => (
                <div key={`dup-${partner.id}`} className="partner-card">
                  <div
                    className="partner-logo-circle"
                    style={{
                      backgroundColor: partner.bgLight,
                      borderColor: partner.color,
                    }}
                  >
                    <img
                      src={partner.logo}
                      alt={partner.name}
                      className="partner-image"
                      onError={(e) => {
                        e.target.style.display = "none";
                        e.target.nextSibling.style.display = "flex";
                      }}
                    />
                    <div
                      className="partner-fallback"
                      style={{ display: "none" }}
                    >
                      <span>{getInitials(partner.name)}</span>
                    </div>
                  </div>
                  <h5 className="partner-name" style={{ color: partner.color }}>
                    {partner.name}
                  </h5>
                </div>
              ))}
            </div>
          </div>
        </div>

        {/* Trust indicator */}
        <div className="text-center mt-5">
          <p className="small text-muted">
            <i
              className="fas fa-check-circle me-1"
              style={{ color: "#D4AF37" }}
            ></i>
            Associated with India's leading financial infrastructure providers
          </p>
        </div>
      </div>

      <style>{`
        .partner-section {
          background: linear-gradient(135deg, #FFFFFF 0%, #F8FAFE 100%);
          overflow-x: hidden;
        }

        .partner-badge {
          background: rgba(212, 175, 55, 0.12);
          padding: 8px 20px;
          border-radius: 40px;
          display: inline-block;
          font-size: 0.85rem;
          font-weight: 600;
          color: #B8860B;
        }

        /* Carousel Wrapper */
        .carousel-wrapper {
          width: 100%;
          overflow: hidden;
          position: relative;
          padding: 20px 0;
        }

        /* Gradient masks for smooth edges */
        .carousel-wrapper::before,
        .carousel-wrapper::after {
          content: '';
          position: absolute;
          top: 0;
          bottom: 0;
          width: 80px;
          z-index: 2;
          pointer-events: none;
        }

        .carousel-wrapper::before {
          left: 0;
          background: linear-gradient(to right, #F8FAFE, transparent);
        }

        .carousel-wrapper::after {
          right: 0;
          background: linear-gradient(to left, #F8FAFE, transparent);
        }

        /* Logo Carousel */
        .logo-carousel {
          display: flex;
          animation: scrollLeft 20s linear infinite;
          width: max-content;
        }

        .carousel-wrapper:hover .logo-carousel {
          animation-play-state: paused;
        }

        @keyframes scrollLeft {
          0% {
            transform: translateX(0);
          }
          100% {
            transform: translateX(-50%);
          }
        }

        /* Carousel Slide */
        .carousel-slide {
          display: flex;
          gap: 3rem;
          padding: 0 1.5rem;
        }

        /* Partner Card */
        .partner-card {
          text-align: center;
          flex-shrink: 0;
          transition: all 0.3s ease;
          cursor: pointer;
        }

        .partner-card:hover {
          transform: translateY(-8px);
        }

        .partner-logo-circle {
          width: 120px;
          height: 120px;
          border-radius: 50%;
          display: flex;
          align-items: center;
          justify-content: center;
          margin-bottom: 1rem;
          transition: all 0.3s ease;
          border: 2px solid;
          box-shadow: 0 10px 25px -5px rgba(0, 0, 0, 0.1);
          overflow: hidden;
          position: relative;
        }

        .partner-card:hover .partner-logo-circle {
          box-shadow: 0 20px 35px -8px rgba(0, 0, 0, 0.15);
          transform: scale(1.05);
        }

        .partner-image {
          width: 70%;
          height: 70%;
          object-fit: contain;
        }

        .partner-fallback {
          width: 100%;
          height: 100%;
          display: flex;
          align-items: center;
          justify-content: center;
          background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
          color: white;
          font-size: 2.5rem;
          font-weight: bold;
        }

        .partner-name {
          font-weight: 700;
          font-size: 1.1rem;
          margin-bottom: 0;
          letter-spacing: 0.5px;
        }

        /* Responsive Design */
        @media (max-width: 768px) {
          .carousel-slide {
            gap: 2rem;
          }
          
          .partner-logo-circle {
            width: 90px;
            height: 90px;
          }
          
          .partner-name {
            font-size: 0.9rem;
          }

          .carousel-wrapper::before,
          .carousel-wrapper::after {
            width: 40px;
          }

          .partner-fallback {
            font-size: 1.8rem;
          }
        }

        @media (max-width: 576px) {
          .carousel-slide {
            gap: 1.5rem;
          }
          
          .partner-logo-circle {
            width: 70px;
            height: 70px;
          }
          
          .partner-name {
            font-size: 0.75rem;
          }

          .partner-fallback {
            font-size: 1.4rem;
          }
        }
      `}</style>
    </section>
  );
};

export default PartnerSection;
